/* eslint-disable react/no-multi-comp */
import React from 'react';

import { Icon, IconColor } from '@vk-hr-tek/ui/Icon';

import { Resources } from '../ability';

const SidebarCandidatesPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="user_square_on_square_outline" size="24" color={color} />;

const SidebarCompetenciesPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="user_check_outline" size="24" color={color} />;

const SidebarEmployeesPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="users_3_outline" size="24" color={color} />;

const SidebarSurveyPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="rectangle_2_horizontal_outline" size="24" color={color} />;

const SidebarEventsPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="article_box_outline" size="24" color={color} />;

const AdvertisingOutlineIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="advertising_outline" size="24" color={color} />;

const SidebarMyCalendarPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="calendar_outline" size="24" color={color} />;

const SidebarPayslipsPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="wallet_outline" size="24" color={color} />;

const SidebarPersonalPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="user_square_outline" size="24" color={color} />;

const SidebarPolicyPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="document_outline" size="24" color={color} />;

const SidebarCompanyPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="vkhrtek_company_page" size="24" color={color} />;

const SidebarSettingsPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="gear_outline" size="24" color={color} />;

const SidebarVacationsPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="vkhrtek_vacations_page" size="24" color={color} />;

const SidebarHomePageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="home_outline" size="24" color={color} />;

const SidebarLogoVkAdsIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="logo_vk_ads_outline" size="24" color={color} />;

const SidebarNewsPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="advertising_outline" size="24" color={color} />;

const SidebarSocialServicesPageIcon = ({
  color = 'text.light.primary',
}: {
  color?: IconColor;
}) => <Icon name="hand_heart_outline" size="24" color={color} />;

export interface Module {
  basename: string;
  icon?: React.ComponentType<{
    color?: IconColor;
  }>;
  resource: Resources;
  parentResource?: Resources;
  withSide: boolean;
  link?: string;
}

export type ModulesNames =
  | 'main'
  | 'news'
  | 'widgets'
  | 'header'
  | 'sideMenu'
  | 'auth'
  | 'user'
  | 'create_certificate'
  | 'personal'
  | 'events'
  | 'dropdown_events'
  | 'paper'
  | 'candidates'
  | 'employees'
  | 'company'
  | 'policy'
  | 'absences'
  | 'payslips'
  | 'structure'
  | 'dropdown_settings'
  | 'settings'
  | 'event_types'
  | 'templates'
  | 'groups'
  | 'profiles'
  | 'substitutes'
  | 'settings_vacations'
  | 'attorneys'
  | 'attorneys_users'
  | 'sign_types'
  | 'social_news'
  | 'vacations'
  | 'competencies'
  | 'bell_notifications'
  | 'vacations'
  | 'personal'
  | 'social_access'
  | 'quiz'
  | 'review'
  | 'dropdown_social_services'
  | 'social_categories'
  | 'social_services'
  | 'company_services'
  | 'company_events'
  | 'employee_services';

export type ModulesConfig = Record<ModulesNames, Module>;

export const modules: ModulesConfig = {
  main: {
    basename: 'dashboard',
    resource: 'Dashboard',
    link: '/',
    icon: SidebarHomePageIcon,
    withSide: true,
  },

  widgets: {
    basename: '',
    resource: 'Dashboard',
    withSide: true,
  },

  news: {
    basename: 'news',
    resource: 'GeneralNews',
    parentResource: 'News',
    link: '/news',
    icon: SidebarNewsPageIcon,
    withSide: true,
  },

  sideMenu: {
    basename: 'sideMenu',
    resource: 'all',
    withSide: false,
  },

  header: {
    basename: 'header',
    resource: 'all',
    withSide: false,
  },

  auth: {
    basename: 'auth',
    resource: 'all',
    withSide: false,
  },

  user: {
    basename: 'profile',
    resource: 'User',
    withSide: false,
  },

  create_certificate: {
    basename: 'create-certificate',
    resource: 'User',
    withSide: false,
  },

  personal: {
    basename: 'personal',
    resource: 'Personal',
    link: '/personal',
    icon: SidebarPersonalPageIcon,
    withSide: true,
  },

  dropdown_events: { basename: 'events', resource: 'Events', withSide: true },

  company_events: {
    basename: '',
    resource: 'Events',
    link: '/events',
    withSide: true,
  },

  events: {
    basename: 'events',
    resource: 'Events',
    link: '/events',
    withSide: true,
    icon: SidebarEventsPageIcon,
  },

  paper: {
    basename: 'paper',
    resource: 'PaperEvents',
    parentResource: 'Events',
    withSide: true,
    link: '/company/events/paper',
  },

  review: {
    basename: 'review',
    icon: SidebarLogoVkAdsIcon,
    link: '/review',
    resource: 'Review',
    withSide: true,
  },
  candidates: {
    basename: 'candidates',
    resource: 'Candidates',
    link: '/company/candidates',
    withSide: true,
    icon: SidebarCandidatesPageIcon,
  },

  employees: {
    basename: 'employees',
    resource: 'Employees',
    link: '/company/employees',
    withSide: true,
    icon: SidebarEmployeesPageIcon,
  },

  policy: {
    basename: 'policy',
    resource: 'Policy',
    link: '/policy',
    withSide: true,
    icon: SidebarPolicyPageIcon,
  },

  absences: {
    basename: 'absences',
    resource: 'Absences',
    link: '/absences',
    withSide: true,
    icon: SidebarMyCalendarPageIcon,
  },

  payslips: {
    basename: 'payslips',
    resource: 'Payslips',
    link: '/employee/payslips',
    icon: SidebarPayslipsPageIcon,
    withSide: true,
  },

  structure: {
    basename: 'organization',
    resource: 'Organization',
    link: '/organization',
    withSide: true,
    icon: SidebarCompanyPageIcon,
  },

  settings: {
    basename: 'settings',
    resource: 'Settings',
    icon: SidebarSettingsPageIcon,
    withSide: true,
    link: '/company/settings/company',
  },
  social_services: {
    basename: 'social-services',
    resource: 'SocialServices',
    parentResource: 'SocialServices',
    icon: SidebarSocialServicesPageIcon,
    withSide: true,
  },
  dropdown_social_services: {
    basename: 'social-services',
    resource: 'SocialServices',
    withSide: true,
  },

  dropdown_settings: {
    basename: 'settings',
    resource: 'Settings',
    withSide: true,
  },

  event_types: {
    basename: '',
    parentResource: 'Settings',
    resource: 'SettingsAdmin',
    withSide: true,
    link: '/company/settings/event-types',
  },

  templates: {
    basename: 'templates',
    resource: 'SettingsAdmin',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/templates',
  },

  groups: {
    basename: 'groups',
    resource: 'SettingsAdmin',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/groups',
  },

  profiles: {
    basename: 'profiles',
    resource: 'CompanyProfiles',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/profiles',
  },

  substitutes: {
    basename: 'substitutes',
    resource: 'SettingsAdmin',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/substitutes',
  },

  settings_vacations: {
    basename: 'vacations',
    resource: 'VacationsSettings',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/vacations',
  },

  attorneys: {
    basename: 'attorneys',
    resource: 'Attorneys',
    parentResource: 'Settings',
    link: '/company/settings/attorneys',
    withSide: true,
  },

  attorneys_users: {
    basename: 'attorneys-users',
    resource: 'Attorneys',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/attorneys-users',
  },

  sign_types: {
    basename: 'sign-types',
    resource: 'SettingsAdmin',
    parentResource: 'Settings',
    withSide: true,
    link: '/company/settings/sign-types',
  },

  social_news: {
    basename: 'news',
    resource: 'News',
    link: '/company/news',
    withSide: true,
    icon: AdvertisingOutlineIcon,
  },
  company: {
    basename: 'company',
    resource: 'SettingsAdmin',
    parentResource: 'Settings',
    withSide: true,
    icon: SidebarSettingsPageIcon,
    link: '/company/settings/company',
  },
  social_categories: {
    basename: 'social-categories',
    resource: 'Categories',
    link: '/company/social-categories',
    withSide: true,
  },
  quiz: {
    basename: 'quiz',
    resource: 'Quiz',
    icon: SidebarSurveyPageIcon,
    withSide: true,
    link: '/company/quiz',
  },
  social_access: {
    basename: 'social-access',
    resource: 'SocialAccess',
    withSide: true,
    link: '/company/social-access',
  },
  vacations: {
    basename: 'vacations',
    resource: 'Vacations',
    link: '/vacations',
    withSide: true,
    icon: SidebarVacationsPageIcon,
  },

  competencies: {
    basename: 'competencies',
    resource: 'Competencies',
    withSide: true,
    link: '/employee/competencies',
    icon: SidebarCompetenciesPageIcon,
  },

  bell_notifications: {
    basename: 'notifications',
    resource: 'User',
    withSide: false,
  },

  company_services: {
    basename: 'dashboard.constants.companyServices',
    resource: 'CompanyServices',
    withSide: true,
  },
  employee_services: {
    basename: 'dashboard.constants.employeeServices',
    resource: 'EmployeeServices',
    withSide: true,
  },
};
